import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Divider from '@material-ui/core/Divider';
import SecurityOutlinedIcon from '@material-ui/icons/SecurityOutlined';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { BrandMark } from './nav/BrandMark';
import { lightTokens } from './theme/rafayTheme';

export const GOOGLE_G_ICON =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'%3E%3Cpath fill='%23EA4335' d='M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z'/%3E%3Cpath fill='%234285F4' d='M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z'/%3E%3Cpath fill='%23FBBC05' d='M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z'/%3E%3Cpath fill='%2334A853' d='M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.36-8.16 2.36-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z'/%3E%3C/svg%3E";

// Shown when the 30-minute inactivity timer fires — a warning before
// sessionTimeout.tsx actually signs the user out, not a message shown
// after the fact. "Continue with Google" hands off to the real sign-in
// flow (identityApi.signOut(), same mechanism the rest of the app already
// uses) rather than pretending to silently refresh a token this app has
// no way to refresh in place. "Cancel" just dismisses and resets the
// activity timer, treating the interaction itself as proof the user is
// still there.
export const SessionExpiredDialog = ({
  open,
  onContinue,
  onCancel,
}: {
  open: boolean;
  onContinue: () => void;
  onCancel: () => void;
}) => (
  <Dialog
    open={open}
    onClose={onCancel}
    maxWidth="xs"
    fullWidth
    PaperProps={{ style: { borderRadius: 16 } }}
  >
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      style={{ padding: '40px 40px 32px', textAlign: 'center' }}
    >
      <Box>
        <BrandMark size={40} withText />
      </Box>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width={72}
        height={72}
        borderRadius="50%"
        style={{
          marginTop: 28,
          marginBottom: 20,
          background: lightTokens.tealSoftBg,
          color: lightTokens.teal,
        }}
      >
        <SecurityOutlinedIcon style={{ fontSize: 34 }} />
      </Box>

      <Typography
        variant="h6"
        style={{ fontWeight: 700, color: lightTokens.textPrimary }}
      >
        Authentication required
      </Typography>
      <Typography
        variant="body2"
        style={{ color: lightTokens.textSecondary, marginTop: 8 }}
      >
        Your Google session has expired or additional authorization is required
        to continue.
      </Typography>

      <Button
        variant="outlined"
        fullWidth
        onClick={onContinue}
        style={{
          marginTop: 28,
          height: 50,
          borderRadius: 24,
          borderColor: lightTokens.border,
          textTransform: 'none',
          fontWeight: 500,
          fontSize: 14,
        }}
        startIcon={<img src={GOOGLE_G_ICON} alt="" width={20} height={20} />}
      >
        Continue with Google
      </Button>

      <Box
        display="flex"
        alignItems="center"
        width="100%"
        style={{ gap: 12, margin: '20px 0' }}
      >
        <Divider style={{ flex: 1 }} />
        <Typography variant="caption" color="textSecondary">
          or
        </Typography>
        <Divider style={{ flex: 1 }} />
      </Box>

      <Link
        component="button"
        variant="body2"
        onClick={onCancel}
        style={{ color: lightTokens.textSecondary }}
      >
        Cancel
      </Link>
    </Box>

    <Divider />
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      style={{
        gap: 6,
        padding: '14px 0',
        fontSize: 11.5,
        color: lightTokens.textSecondary,
      }}
    >
      <LockOutlinedIcon style={{ fontSize: 13 }} />
      Secure authentication powered by RAFAY SSO
    </Box>
  </Dialog>
);
